import {useEffect, useState} from 'react';
import {largeNavHeight, smallNavHeight} from "../components/page_layouts/pageLayoutsUtils";
import useWindowSize from "./useWindowSize";

const useNavigationHeight = (isHideNavi?: boolean) => {
    const [navHeight, setNavHeight] = useState('');
    const {greaterThanWindowLarge} = useWindowSize();

    useEffect(() => {
        const calculateNavHeight = () => {
            const calculatedNavHeight: string = greaterThanWindowLarge && !isHideNavi ? largeNavHeight : smallNavHeight;
            setNavHeight(calculatedNavHeight);
        };
        calculateNavHeight();
        const handleResize = () => {
            calculateNavHeight();
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [greaterThanWindowLarge, isHideNavi]);

    return navHeight;
};

export default useNavigationHeight;